<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img src="@/assets/images/logo/logorodopetit.png" alt="Logo" height="32" />
        <h2 class="brand-text text-primary ml-1">Staff Control</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Bienvenido a Staff Control! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Porfavor inicia sesión en tu cuenta.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- user -->
              <b-form-group label="Usuario" label-for="login-email">
                <validation-provider #default="{ errors }" name="Email" rules="required|no-pda">
                  <b-form-input id="login-email" v-model="userEmail" :state="errors.length > 0 ? false : null"
                    name="login-email" placeholder="mbc@example.com" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <validation-provider #default="{ errors }" name="Contraseña" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="login-password" v-model="password" :state="errors.length > 0 ? false : null"
                      class="form-control-merge" :type="passwordFieldType" name="login-password"
                      placeholder="············" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit -->
              <b-button type="submit" variant="primary" block @click="validationForm">
                Iniciar sesión
              </b-button>
            </b-form>
          </validation-observer>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">o</div>
          </div>

          <b-button type="button" variant="info" block @click="adfsLogin">
            BSM - Iniciar sesión
          </b-button>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup,
  BCardText, BCardTitle, BImg, BForm, BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@/libs/axios";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import ability from "@/libs/acl/ability";
import { encryptString } from "@/libs/crypto";

extend("no-pda", {
  validate: (value) => {
    if (value && /^(pda|sj|fm)\./.test(value.toLowerCase())) {
      return "Usuario no válido";
    }
    return true;
  },
});

export default {
  components: {
    BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup,
    BCardText, BCardTitle, BImg, BForm, BButton, ValidationProvider, ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      userEmail: "",
      AdminAbilities: [{ action: "manage", subject: "all" }],
      UserAbilities: [],
      sideImg: require("@/assets/images/pages/LoginMaxseatV2.png"),
      required,
      email,
    };
  },

  async mounted() {
    // LOGIN ADFS: viene con query params user/token
    if (this.$route.query.user && this.$route.query.token) {
      try {
        const response = await axios.post(`/login`, {
          username: this.$route.query.user,
          token: this.$route.query.token,
          active_directory: true,
        });

        await this.finishLogin(response.data[0]);

        await this.$router.replace(getHomeRouteForLoggedInUser("admin"));
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Bienvenido`,
            icon: "CoffeeIcon",
            variant: "success",
            text: `Ha iniciado sesión correctamente.`,
          },
        });
      } catch (error) {
        // Limpia por si había basura previa y evita bloqueos
        localStorage.clear();
        sessionStorage.clear();

        this.$bvToast.toast("Usuario o contraseña incorrectos.", {
          title: "" + error,
          variant: "danger",
          solid: true,
        });
      }
    }
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/pages/LoginMaxseatV2.png");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },

  methods: {
    /**
     * Hace EXACTAMENTE lo mismo para login normal y ADFS:
     * - token
     * - permisos (web + task)
     * - ability
     * - localStorage (con cifrado consistente)
     */
    async finishLogin(user) {
      // 1) Token
      localStorage.setItem("accessToken", user.accessToken);

      // 2) Permisos (igual para ambos flujos)
      this.UserAbilities = [];

      try {
        const web = await axios.get(`/user-web-permissions?ID_user=${user.ID_user.toString()}`);
        web.data.forEach((p) => this.UserAbilities.push(p));
      } catch (e) {
        // si quieres, puedes toast aquí; lo dejo silencioso para no romper login
      }

      try {
        const task = await axios.get(`/user-task-permissions?ID_user=${user.ID_user.toString()}`);
        task.data.forEach((p) => this.UserAbilities.push(p));
      } catch (e) {
        // idem
      }

      // 3) Ability
      if (user.role === "Admin") user.ability = this.AdminAbilities;
      else user.ability = this.UserAbilities;

      ability.update(user.ability);

      // 4) Storage igual y CIFRADO igual (clave del problema en AD)
      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("idUser", encryptString(user.ID_user.toString()));
      localStorage.setItem("Aforo_permit", encryptString(user.Aforo_permit.toString()));
    },

    validationForm() {
      this.$refs.loginValidation.validate().then(async (success) => {
        if (!success) return;

        try {
          const response = await axios.post(`/login`, {
            username: this.userEmail,
            password: this.password,
          });

          await this.finishLogin(response.data[0]);

          await this.$router.replace(getHomeRouteForLoggedInUser("admin"));
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Bienvenido`,
              icon: "CoffeeIcon",
              variant: "success",
              text: `Ha iniciado sesión correctamente.`,
            },
          });
        } catch (error) {
          this.$bvToast.toast("Usuario o contraseña incorrectos.", {
            title: "" + error,
            variant: "danger",
            solid: true,
          });
        }
      });
    },

    async adfsLogin() {
      window.location.href = "https://bsmstaffcontrol.mbcontrol.cat:44395/adfs/login";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>